import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { NoticeComponent } from './notice/notice.component';
import { NotificationConfig, NotificationType } from './notification-config.class';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private activeNoticeRef?: MatSnackBarRef<NoticeComponent>;

  constructor(
    private snackBar: MatSnackBar,
  ) { }

  /**
   * Showing notification
   * @param notice - The message
   * @param type - The type
   * @param permanent - Permanent or auto-dismiss
   * @param hideDismiss - if true, the close button is hidden
   * @param action - action to be done at click on notification
   */
  showNotification(notice: string, type: NotificationType, permanent = false,
    hideDismiss?: boolean, action?: (...args: any[]) => any) {
    const noticeConfig = new NotificationConfig(notice, type, permanent, hideDismiss, action);
    this.activeNoticeRef = this.snackBar.openFromComponent(NoticeComponent, noticeConfig);
  }

  /**
   * Dismiss the notification.
   * Only dismisses the notice this service opened, so it doesn't close an
   * unrelated snackbar (e.g. the touchpoint notification) that happens to be
   * the currently active one on the shared MatSnackBar instance.
   */
  dismissNotification() {
    this.activeNoticeRef?.dismiss();
  }
}
